const getProfileScope = () => {
  const profileId = localStorage.getItem('activeProfileId');
  if (profileId) return `profile:${profileId}`;
  return 'profile:default';
};

const buildKey = (name) => `shortflix:${name}:${getProfileScope()}`;

const getJson = (name, fallback) => {
  try {
    const raw = localStorage.getItem(buildKey(name));
    return raw ? JSON.parse(raw) : fallback;
  } catch (error) {
    return fallback;
  }
};

const setJson = (name, value) => {
  localStorage.setItem(buildKey(name), JSON.stringify(value));
};

const normalizeRating = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  if (parsed < 0) return 0;
  if (parsed > 5) return 5;
  return Math.round(parsed);
};

const userFeatures = {
  getRating(contentId) {
    const ratings = getJson('ratings', {});
    return normalizeRating(ratings[contentId] || 0);
  },

  setRating(contentId, rating) {
    const ratings = getJson('ratings', {});
    ratings[contentId] = normalizeRating(rating);
    setJson('ratings', ratings);
    return ratings[contentId];
  },

  isLiked(contentId) {
    const likes = getJson('likes', {});
    return likes[contentId] === true;
  },

  toggleLike(contentId) {
    const likes = getJson('likes', {});
    likes[contentId] = !likes[contentId];
    setJson('likes', likes);
    return likes[contentId];
  },

  getNotificationPrefs() {
    return getJson('notification_prefs', {
      newContent: true,
      subscription: true,
      promotions: true,
      pushEnabled: false
    });
  },

  setNotificationPrefs(nextPrefs) {
    const prefs = {
      ...this.getNotificationPrefs(),
      ...nextPrefs
    };
    setJson('notification_prefs', prefs);
    return prefs;
  }
};

export default userFeatures;
